import React, { createContext, useContext, useRef, useState, useEffect, useReducer } from 'react';
import { words, colors } from './moodMeterData';
import Cell from './cell';
import { div } from '@material-ui/core';

const MOOD = (props) => {
    const { onAnswer, questionIndex } = props;
    const [mood, setMood] = useState('');
    const [data, setData] = useState([]);

    useEffect(() => {
        init();
    }, [])

    useEffect(() => {
        if (mood) {
            var data = {
                word: mood.word,
                energy: mood.position.y,
                pleasantness: mood.position.x
            }
            if (onAnswer) {
                onAnswer(JSON.stringify(data), questionIndex);
            }
        }
    }, [mood])

    const init = () => {
        let tmp = [];
        for (var i = 0; i < 10; i++) {
            let row = [];
            for (var j = 0; j < 10; j++) {
                row.push({
                    position: {x: i, y: j},
                    color: colors[i][j],
                    word: words[i][j]
                })
            }
            tmp.push(row);
        }
        setData(tmp);
    }

    const renderMatrix = () => {
        return (
            data.map((row, index) => (
                <div key={'mood-meter-row-' + index} className="mood-row">
                    {row.map((cell, index) => (
                        <Cell 
                            key={'mood-meter-cell-' + index}
                            color={cell.color}
                            word={cell.word}
                            position={cell.position}
                            mood={mood}
                            setMood={setMood}
                        />
                    ))}
                </div>
            ))
        )
    }

    const onClick = ({x, y}) => {
        if (x >= 0 && x <= 9) {
            setMood({
                word: words[x][y],
                position: {x, y}
            })
        }
    }

    const renderWord = ({x, y}) => {
        try {
            if (x >= 0 && x <= 9) {
                if (mood.word === words[x][y]) {
                    return (
                        <div className="mood-mood">
                            <div>{mood.word}</div>
                        </div>
                    )
                }
                const word = words[x][y] !== undefined ? words[x][y] : '';
                return (
                    <div className="mood-word" onClick={() => onClick({x, y})}>
                        {word}
                    </div>
                )
            }
        } catch (e) {
            console.log("ERROR >>>", e);
        }
    }
    
    return (
        <div style={{width: '100%', alignSelf: 'center'}}>
            {renderMatrix()}

            {mood ? (
                <div style={{width: '100%'}} className="mt-3">
                    <div className="mood-word-row">
                        {renderWord({x: mood.position.x - 1, y: mood.position.y - 1})}
                        {renderWord({x: mood.position.x - 1, y: mood.position.y})}
                        {renderWord({x: mood.position.x - 1, y: mood.position.y + 1})}
                    </div>

                    <div className="mood-word-row">
                        {renderWord({x: mood.position.x, y: mood.position.y - 1})}
                        {renderWord(mood.position)}
                        {renderWord({x: mood.position.x, y: mood.position.y + 1})}
                    </div>

                    <div className="mood-word-row">
                        {renderWord({x: mood.position.x + 1, y: mood.position.y - 1})}
                        {renderWord({x: mood.position.x + 1, y: mood.position.y})}
                        {renderWord({x: mood.position.x + 1, y: mood.position.y + 1})}
                    </div>
                </div>
            ) : (
                <div className="text-center mt-3 mb-5">SELECT A CELL TO START</div>
            )}
        </div>
    )
}

export default MOOD;